// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__256b5","content":"LoadingAlert_content__vXi50"};